var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1329 1.6665H4.86193C4.47651 1.6665 4.16406 1.97895 4.16406 2.36437C4.16406 4.58541 5.04636 6.71547 6.61687 8.28598L7.63286 9.30197C7.73375 9.40286 7.7842 9.45331 7.82032 9.50175C8.04063 9.79727 8.04063 10.2024 7.82032 10.4979C7.7842 10.5464 7.73375 10.5968 7.63286 10.6977L6.61687 11.7137C5.04636 13.2842 4.16406 15.4143 4.16406 17.6353C4.16406 18.0207 4.47651 18.3332 4.86193 18.3332H15.1329C15.5183 18.3332 15.8307 18.0207 15.8307 17.6353C15.8307 15.4143 14.9484 13.2842 13.3779 11.7137L12.3619 10.6977C12.261 10.5968 12.2106 10.5464 12.1745 10.4979C11.9542 10.2024 11.9542 9.79727 12.1745 9.50175C12.2106 9.45331 12.261 9.40286 12.3619 9.30197L13.3779 8.28598C14.9484 6.71547 15.8307 4.58541 15.8307 2.36437C15.8307 1.97895 15.5183 1.6665 15.1329 1.6665Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.9d890bd7290a227ed689849fa3e468a6.svg";
export { ForwardRef as ReactComponent };